import {api} from './api';
import {
  Settings,
  UpdateSettingsRequest,
  UpdateUserRequest,
  User,
} from '../types';

export const settingsService = {
  async getSettings(): Promise<Settings> {
    return api.get<Settings>('/api/v1/settings');
  },

  async updateSettings(request: UpdateSettingsRequest): Promise<Settings> {
    return api.patch<Settings>('/api/v1/settings', request);
  },

  async getCurrentUser(): Promise<User> {
    return api.get<User>('/api/v1/user/me');
  },

  async updateUser(request: UpdateUserRequest): Promise<User> {
    return api.patch<User>('/api/v1/user/me', request);
  },

  async resendVerificationEmail(): Promise<void> {
    await api.post<{message: string}>('/api/v1/user/me/resend-verification', {});
  },

  async getOAuthStatus(): Promise<OAuthStatus> {
    return api.get<OAuthStatus>('/api/v1/oauth/status');
  },

  async getCalendarAuthUrl(platform?: 'web' | 'native'): Promise<{authorizationUrl: string}> {
    const query = platform ? `?platform=${platform}` : '';
    return api.get<{authorizationUrl: string}>(
      `/api/v1/oauth/google/calendar/authorize${query}`,
    );
  },

  async disconnectCalendar(): Promise<void> {
    await api.delete('/api/v1/oauth/google/calendar');
  },

  async getPhotosAuthUrl(platform?: 'web' | 'native'): Promise<{authorizationUrl: string}> {
    const query = platform ? `?platform=${platform}` : '';
    return api.get<{authorizationUrl: string}>(
      `/api/v1/oauth/google/photos/authorize${query}`,
    );
  },

  async disconnectPhotos(): Promise<void> {
    await api.delete('/api/v1/oauth/google/photos');
  },

  async exchangeOAuthCode(code: string, state: string): Promise<void> {
    await api.post('/api/v1/oauth/google/exchange', {code, state});
  },

  async deleteAccount(): Promise<void> {
    await api.delete('/api/v1/user/me');
  },
};

export interface OAuthStatus {
  calendarConnected: boolean;
  photosConnected: boolean;
  calendarEmail?: string;
  photosEmail?: string;
}
